package com.gsb.vyapar.bhagya.presentation.admin.uistate

import androidx.compose.runtime.mutableStateMapOf
import androidx.compose.runtime.snapshots.SnapshotStateMap
import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.domain.User
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState

data class AdminUiState(
    val title: String = "Admin",
    val userBusinessMap: SnapshotStateMap<User, List<Business>> = mutableStateMapOf(),
) {
    fun updateUserBusinessMap(userBusinessMap: SnapshotStateMap<User, List<Business>>) {
        updateAdminUiState(this.copy(userBusinessMap = userBusinessMap))
    }
}

fun updateAdminUiState(adminUiState: AdminUiState) {
    updateState(getState().copy(adminUiState = adminUiState))
}

fun getAdminUiState(): AdminUiState {
    return getState().adminUiState
}
